<template>
  <div
    v-if="article"
    class="post-wrap"
  >
    <ArticleContentRender
      :content="article.content"
      :preloaded-data="preloadedData"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed, onBeforeMount, ref, watchEffect } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  import { ArticleContentRender } from '@/features/articleContent';
  import type { PreloadedData } from '@/features/articleContent/lib/articleComponents';
  import type { LinkCardComponent } from '@/features/articleContent/models/ArticleContent';
  import { articles, linkedArticles } from '@/pages/article/fixtures';

  import type { Article } from '@/pages/article/models/Article';

  const router = useRouter();
  const route = useRoute();
  const articleSlug = computed(() => (route.params.slug ? String(route.params.slug) : null));
  const article = ref<Article | null>(null);
  const preloadedData = ref<PreloadedData>({
    linkedArticles: [],
  });

  const loadingFailed = ref(false);

  watchEffect(() => {
    if (loadingFailed.value) {
      // перенаправляем на главную страницу журнала, если загрузка автора не удалась.
      router.replace('/');
    }
  });

  onBeforeMount(() => fetchData());

  const fetchData = () => {
    const slug = articleSlug.value;

    if (!slug) {
      loadingFailed.value = true;
    }

    const foundArticle = articles.find((art) => art.slug === slug);

    if (!foundArticle) {
      loadingFailed.value = true;

      return;
    }

    article.value = foundArticle;

    const linked: LinkCardComponent[] = [];

    for (let i = 0; i < foundArticle.content.length; ++i) {
      const item = foundArticle.content[i];

      if (item.type === 'vue' && item.attrs.component === 'link-card') {
        linked.push(item.attrs);
      }
    }

    preloadedData.value = {
      linkedArticles: linkedArticles.filter((linkedArticle) => {
        const strId = String(linkedArticle.id);

        return Boolean(linked.find((linkedItem) => linkedItem.id === strId && linkedItem.type === linkedArticle.type));
      }),
    };
  };
</script>

<style lang="scss">
  @import '@/app/styles/post_page';
</style>
